import Header from "../components/Header";
import logovi from "@/assets/img/logovi.png";
import logoen from "@/assets/img/logoen.png";
import { useTranslation } from "react-i18next";
import { Language } from "@/shared/enumeration/language";
const CaiDatNgonNgu = () => {
  const { t, i18n }: { t: (key: string) => string; i18n: any } =
    useTranslation();
  const changeLang = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  const getLang = () => {
    return i18n.language;
  };
  return (
    <div className="wrapper">
      <div className="container-web thanvan bgnew">
        <Header title={t("Cài đặt ngôn ngữ")} />

        <div className="mt-3">
          <div
            style={{ color: getLang() === Language.vi ? "#deaa4f" : "" }}
            className="d-flex align-items-center justify-content-between px-3 py-2"
            onClick={() => changeLang(Language.vi)}
          >
            <div className="d-flex align-items-center gap-2">
              <img
                src={logovi}
                alt=""
                style={{ width: 20, height: 20, borderRadius: "50%" }}
              />
              <span>{t("Việt Nam")}</span>
            </div>
            {getLang() === Language.vi && (
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
            )}
          </div>

          <div
            style={{ color: getLang() === Language.en ? "#deaa4f" : "" }}
            className="d-flex align-items-center justify-content-between px-3 py-2"
            onClick={() => changeLang(Language.en)}
          >
            <div className="d-flex align-items-center gap-2">
              <img
                src={logoen}
                alt=""
                style={{ width: 20, height: 20, borderRadius: "50%" }}
              />
              <span>{t("English")}</span>
            </div>
            {getLang() === Language.en && (
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaiDatNgonNgu;
